<template>
    <div class="content_container">
      <el-scrollbar>
        <div class="container">
          更新中……
        </div>
      </el-scrollbar>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Index",
  components: {
    
  },
  data() {
    return {
        navActiveIndex: '1', //当前菜单项
        defaultOpeneds:[''], //菜单默认展开项
      };
  }
};
</script>
